import { dialogs, i18next, integration, saving } from '@yola/ws-sdk';
import store from 'src/js/store';
import dialogTypes from 'src/js/modules/dialogs/constants/dialog-types';
import optionIds from '../constants/option-ids';
import trackDesignMenuItemClick from '../trackers/track-design-menu-item-click';

const getDesignMenuItemClickCallbacks = (sourceId) => {
  const state = store.getState();
  const savingStatus = saving.selectors.getStatus(state);
  const integrationSettings = integration.selectors.getSettings(state);

  const onUnsavedActivePageChange = (callback) => {
    store.dispatch(
      dialogs.actions.show(dialogTypes.UNSAVED_WARNING, {
        callback,
        captions: { title: i18next.t('Your site has unsaved changes') },
      })
    );
  };

  const handleSwitchTemplate = () => {
    const { UNSAVED } = saving.constants.statuses;
    if (savingStatus === UNSAVED) {
      onUnsavedActivePageChange(integrationSettings.onSwitchTemplate);
    } else {
      integrationSettings.onSwitchTemplate({
        sendAnalytics: true,
        traits: {
          sourceId,
        },
      });
    }
  };

  return {
    colorsOnClick: () => {
      trackDesignMenuItemClick(optionIds.COLORS);
      store.dispatch(
        dialogs.actions.show(dialogTypes.DESIGN_SETTINGS_COLORS_DIALOG, {
          sourceId,
        })
      );
    },
    fontsOnClick: () => {
      trackDesignMenuItemClick(optionIds.FONTS);
      store.dispatch(
        dialogs.actions.show(dialogTypes.DESIGN_SETTINGS_FONTS_DIALOG, {
          sourceId,
        })
      );
    },
    buttonsOnClick: () => {
      trackDesignMenuItemClick(optionIds.BUTTONS);
      store.dispatch(
        dialogs.actions.show(dialogTypes.DESIGN_SETTINGS_BUTTONS_DIALOG, {
          sourceId,
        })
      );
    },
    effectsOnClick: () => {
      trackDesignMenuItemClick(optionIds.EFFECTS);
      store.dispatch(
        dialogs.actions.show(dialogTypes.DESIGN_SETTINGS_EFFECTS_DIALOG, {
          sourceId,
        })
      );
    },
    otherStylesOnClick: () => {
      trackDesignMenuItemClick(optionIds.OTHER_STYLES);
      store.dispatch(
        dialogs.actions.show(dialogTypes.DESIGN_SETTINGS_OTHER_STYLES_DIALOG, {
          sourceId,
        })
      );
    },
    switchTemplateOnClick: () => handleSwitchTemplate(),
  };
};

export default getDesignMenuItemClickCallbacks;
